import React, { useEffect, useState } from 'react'

import {
  Container,
  Popover,
  Button,
  LabelWrapper,
  IconWrapper,
} from '@components/DrawButton/styles'

import { Count, Option } from './styles'
import { Layers, Checkbox } from '@icons'

const ViewButton = ({ submit, ...rest }) => {
  const [active, setActive] = useState(false)
  const [view, setView] = useState(rest.view)

  const handleClick = event => {
    const button = document.getElementById('viewButton')
    const container = document.getElementById('viewButtonContainer')

    if (
      (button && button.contains(event.target)) ||
      (container && container.contains(event.target))
    )
      return

    setActive(false)
    // active && submit(view)
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClick, true)

    return () => {
      document.removeEventListener('mousedown', handleClick, true)
    }
  })

  useEffect(() => {
    submit(view)
  }, [view])

  const setOption = option => {
    if (option === 'neighborhoods')
      setView({
        ...view,
        [option]: !view[option],
        zones: false,
      })
    else if (option === 'zones')
      setView({
        ...view,
        [option]: !view[option],
        neighborhoods: false,
      })
    else setView({ ...view, [option]: !view[option] })
  }

  const handleButtonClick = () => setActive(!active)

  const getCount = () => {
    return Object.keys(view).filter(key =>
      key === 'zones' ? rest.zonings && !!view[key] : !!view[key],
    ).length
  }

  return (
    <Container view className="DrawButtonComponent">
      {active && (
        <Popover view id="viewButtonContainer">
          <Option onClick={() => setOption('neighborhoods')}>
            <Checkbox checked={view.neighborhoods} />
            <p>Bairros</p>
          </Option>
          {rest.zonings && (
            <Option onClick={() => setOption('zones')}>
              <Checkbox checked={view.zones} />
              <p>Zoneamento</p>
            </Option>
          )}
          <Option onClick={() => setOption('satellite')}>
            <Checkbox checked={view.satellite} />
            <p>Satélite</p>
          </Option>
        </Popover>
      )}
      <Button view id="viewButton" type="button" onClick={handleButtonClick}>
        <LabelWrapper>
          <IconWrapper>
            <Layers />
          </IconWrapper>
          Visualizar
          <Count>{getCount()}</Count>
        </LabelWrapper>
      </Button>
    </Container>
  )
}

export default ViewButton
